module.exports = __webpack_public_path__ + "fonts/Montserrat-400-15.551b13d.woff2";